module.exports = __webpack_public_path__ + "static/media/parent-icon.a3908b92.svg";